module.exports = {
      id: "comm-spiritual-usage",
      viewBox: "0 0 271.278 58.643",
      url: "/" + "sprite-ab56b996b385d9abaaf31e01c38c81cd.svg#comm-spiritual",
      toString: function () {
        return this.url;
      }
    }